module.exports = __webpack_public_path__ + "img/user.requesting.service.1.8a1a61d4.jpg";